<template>
    <div id="app">
        <!-- The router-view will load the appropriate component (e.g., Login, Dashboard, etc.) 
             based on the current route and authentication status, managed by the router guards. -->
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    created() {
        document.title = process.env.VUE_APP_TITLE;
    },
    data: function () {
        return { 
            status: false 
        };
    },
    mounted() {
        $("ul.tabs li").click(function () {
            var $this = $(this);
            var $theTab = $(this).attr("id");
            console.log($theTab);
            if ($this.hasClass("active")) {
            } else {
                $this
                    .closest(".tabs_wrapper")
                    .find("ul.tabs li, .tabs_container .tab_content")
                    .removeClass("active");
                $(
                    '.tabs_container .tab_content[data-tab="' +
                    $theTab +
                    '"], ul.tabs li[id="' +
                    $theTab +
                    '"]'
                ).addClass("active");
            }
        });

    },
};
</script>
